import React from 'react';

export default class BackgroundSquare extends React.Component {

  render() {
    const scrollProgressType = this.props.scrollProgressType ? this.props.scrollProgressType : null

    return (
      <div className="square-container">
        <div className="square" data-scroll-item-progress={scrollProgressType}>
          <div className="inner"></div>
        </div>
      </div>
    );
  }

};
